<template>
    <div>
        <router-link :to="{name: 'tag-create' }" class="button is-primary is-pulled-right">
            Add tag
        </router-link>

        <data-table :data-set="tags" :columns="[
            {name: 'Name', type: 'text', prop: 'name'},
            {name: 'Updated', type: 'date', prop: 'updated_at', filter: ['moment', ['from', 'now']]},
            {name: 'Created', type: 'date', prop: 'created_at', filter: ['moment', ['from', 'now']]},
        ]">
            <template slot="column_Name" slot-scope="props">
                <router-link :to="{name: 'tag', params: {id: props.row.id}}">
                    {{ props.row.name }}
                </router-link>
            </template>
            <template slot="controls" slot-scope="props">
                <td>
                    <div class="has-text-right">
                        <a class="delete" @click="deleteTag(props.row)"></a>
                    </div>
                </td>
            </template>
        </data-table>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {DELETE_TAG} from "../../../store/mutation-types";
    export default {
        name: 'tag-list',
        data () {
            return {}
        },
        computed: mapGetters(['tags']),
        methods: {
            deleteTag(tag) {
                this.$store.dispatch(DELETE_TAG, tag)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// TagList.vue?0add1dd6